import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import WidgetCard from "../widget/card";
import { FormattedMessage } from "react-intl";
import { Button } from "@ts-digital/vrc";

const WidgetTSPay = () => {  
  const navigate = useNavigate();
  return (
    <div className={"cardSkeletonTSPay noBoxShadow"}>
      <WidgetCard type="cardSkeletonTSPay TSPayBanner"
        titleWidget="">
        <div style={{display: "flex", justifyContent: "center", width:"100%", marginTop: "7px"}}>
          <div style={{marginRight: "10px", fontSize:"30px", fontWeight:"300"}}><FontAwesomeIcon icon={["fal", "university"]}/></div>
          <div style={{fontSize:"24px", alignSelf: "center"}}>TS Pay</div>
        </div>
        <div style={{fontSize:"12px", margin: "7px 60px 10px 60px"}}>{<FormattedMessage id="customersWidget.tsPayBanner" />}</div>
        <Button className={"tspayButtonBanner"} style={{color:"white", borderColor:"white"}}
          kind="secondary"
          colorScheme={"ghost"}
          onClick={() => {
            navigate("/landing-no-tspay");
            if (window.aptrinsic) {
              window.aptrinsic("track", "digital-box:TSPAY-SCOPRI");
            }
          }}
        >
          <FormattedMessage id="actions.discoverMore" />
        </Button>
      </WidgetCard>
    </div>
  );

};

export default WidgetTSPay;
